export class Transaction {
  serviceType?: number;
  accepted?: number;
  proccessed?: number;
  receiptNumber: string;
  amount?: number;
  recivedAccount?: string;
  requestDate?: Date;
  toDate: Date;
  fromDate: Date;
  lastUpdate?: Date;
  gateID?: number;
  gateName: string;
  gateServiceID?: number;
  protocolID?: number;
  extraParams: string;
  partnerTranID: string;
  serviceName: string;
  serviceID?: number;
  code?: number;
  transactionID?: number;
  agentID?: number;
  agentName: string;
  tryCount?: number;
  reciveAgentName: string;
  terminalID?: number;
  receiveAgentID?: number;
  accountName: string;
  transactionType?: number;
  transactionTypeName: string;
  status?: number;
  accountID?: number;
  totalProcessGate?: number;
  batchType: number;
  numberItems: number;
  totalProccessed: number;
  info: string;

  // 
  ServiceType?: number;
  Accepted?: number;
  Proccessed?: number;
  ReceiptNumber: string;
  Amount?: number;
  RecivedAccount?: string;
  RequestDate?: Date;
  ToDate: Date;
  FromDate: Date;
  LastUpdate?: Date;
  GateID?: number;
  GateName: string;
  GateServiceID?: number;
  ProtocolID?: number;
  ExtraParams: string;
  PartnerTranID: string;
  ServiceName: string;
  ServiceID?: number;
  Code?: number;
  TransactionID?: number;
  AgentID?: number;
  AgentName: string;
  TryCount?: number;
  ReciveAgentName: string;
  TerminalID?: number;
  ReceiveAgentID?: number;
  AccountName: string;
  TransactionType?: number;
  TransactionTypeName: string;
  Status?: number;
  AccountID?: number;
  TotalProcessGate?: number;
  BatchType: number;
  NumberItems: number;
  TotalProccessed: number;
  Info: string;

  constructor() { }

  
}
